/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrerequisiteType } from './PrerequisiteType';
import {
    PrerequisiteTypeFromJSON,
    PrerequisiteTypeFromJSONTyped,
    PrerequisiteTypeToJSON,
    PrerequisiteTypeToJSONTyped,
} from './PrerequisiteType';
import type { EventValidatorResponse } from './EventValidatorResponse';
import {
    EventValidatorResponseFromJSON,
    EventValidatorResponseFromJSONTyped,
    EventValidatorResponseToJSON,
    EventValidatorResponseToJSONTyped,
} from './EventValidatorResponse';

/**
 * 
 * @export
 * @interface PrerequisiteResponse
 */
export interface PrerequisiteResponse {
    /**
     * 
     * @type {string}
     * @memberof PrerequisiteResponse
     */
    id: string;
    /**
     * 
     * @type {PrerequisiteType}
     * @memberof PrerequisiteResponse
     */
    prerequisiteType: PrerequisiteType;
    /**
     * 
     * @type {string}
     * @memberof PrerequisiteResponse
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PrerequisiteResponse
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof PrerequisiteResponse
     */
    nftGroupingId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrerequisiteResponse
     */
    questId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrerequisiteResponse
     */
    guildId?: string;
    /**
     * 
     * @type {EventValidatorResponse}
     * @memberof PrerequisiteResponse
     */
    event?: EventValidatorResponse;
    /**
     * 
     * @type {string}
     * @memberof PrerequisiteResponse
     */
    challengeId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrerequisiteResponse
     */
    activationId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrerequisiteResponse
     */
    streakConfigId?: string;
}



/**
 * Check if a given object implements the PrerequisiteResponse interface.
 */
export function instanceOfPrerequisiteResponse(value: object): value is PrerequisiteResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('prerequisiteType' in value) || value['prerequisiteType'] === undefined) return false;
    return true;
}

export function PrerequisiteResponseFromJSON(json: any): PrerequisiteResponse {
    return PrerequisiteResponseFromJSONTyped(json, false);
}

export function PrerequisiteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrerequisiteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'prerequisiteType': PrerequisiteTypeFromJSON(json['prerequisiteType']),
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'nftGroupingId': json['nftGroupingId'] == null ? undefined : json['nftGroupingId'],
        'questId': json['questId'] == null ? undefined : json['questId'],
        'guildId': json['guildId'] == null ? undefined : json['guildId'],
        'event': json['event'] == null ? undefined : EventValidatorResponseFromJSON(json['event']),
        'challengeId': json['challengeId'] == null ? undefined : json['challengeId'],
        'activationId': json['activationId'] == null ? undefined : json['activationId'],
        'streakConfigId': json['streakConfigId'] == null ? undefined : json['streakConfigId'],
    };
}

export function PrerequisiteResponseToJSON(json: any): PrerequisiteResponse {
    return PrerequisiteResponseToJSONTyped(json, false);
}

export function PrerequisiteResponseToJSONTyped(value?: PrerequisiteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'prerequisiteType': PrerequisiteTypeToJSON(value['prerequisiteType']),
        'description': value['description'],
        'amount': value['amount'],
        'nftGroupingId': value['nftGroupingId'],
        'questId': value['questId'],
        'guildId': value['guildId'],
        'event': EventValidatorResponseToJSON(value['event']),
        'challengeId': value['challengeId'],
        'activationId': value['activationId'],
        'streakConfigId': value['streakConfigId'],
    };
}

